// extracted by mini-css-extract-plugin
export default {"switch":"switch_switch__kT5HV","focused":"switch_focused__IlnVu"};